import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import {
  LeafAuthGuardModule, LeafAuthGuardService,
} from '@input-output-labs/ngleaf';
import { MainLayoutComponent } from 'component/main-layout/main-layout.component';
import { MainLayoutModule } from 'component/main-layout/main-layout.module';

const routes: Route[] = [
  {
    path: '',
    canActivate: [LeafAuthGuardService],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/reports',
        pathMatch: 'full',
      },
      {
        path: 'pdftemplates',
        loadChildren: () => import('./pdftemplate/pdftemplate.module').then(m => m.PDFTemplateModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./periodic-reports/periodic-reports.module').then(m => m.PeriodicReportsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./account-settings/account-settings.module').then(m => m.AccountSettingsModule)
      },
      {
        path: 'organization',
        loadChildren: () => import('./organization/organization.module').then(m => m.OrganizationModule)
      },
      {
        path: 'members-rights',
        loadChildren: () => import('./members-rights/members-rights.module').then(m => m.MembersRightsModule)
      },
      {
        path: 'gireve-import',
        loadChildren: () => import('./gireve-import/gireve-import.module').then(m => m.GireveImportModule)
      },
      {
        path: 'bank-transfer',
        loadChildren: () => import('./bank-transfer/bank-transfer.module').then(m => m.BankTransferModule)
      },
      {
        path: 'admin/organizations',
        loadChildren: () => import('./admin/organizations/organizations.module').then(m => m.OrganizationsModule)
      },
      {
        path: 'admin/workspace-settings',
        loadChildren: () => import('./admin/workspace-settings/workspace-settings.module').then(m => m.WorkspaceSettingsModule)
      },
    ]
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    LeafAuthGuardModule,
    MainLayoutModule,
  ], // add { enableTracing: true } after routes in forRoot to debug the router
  exports: [RouterModule],
})
export class AppRouteModule {}

